import BuildCredentialingEmailHtmlApi from '../../../services/general/buildCredentialingEmailHtml.api'
import CreateDraftMail from '../../../services/general/createDraftMail.api'
import FetchCredentialingEmailRepliesApi from '../../../services/general/fetchCredentialingEmailReplies.api'
import MarkCredentialingReplyAsReadApi from '../../../services/general/markCredentialingReplyAsRead.api'
import SendCredentialingEmailApi from '../../../services/general/sendCredentialingEmail.api'
import SyncCredentialingEmailThreadApi from '../../../services/general/syncCredentialingEmailThread.api'
import { formatValueToMMDDYYYY } from '../../../components/shared/customDateFormatUtils'

export const CREDENTIAL_TASK_TEMPLATE_TYPES = {
  CREDENTIALING: 'credentialing-task',
}

export const CREDENTIAL_TASK_TEMPLATE_OPTIONS = [
  { value: CREDENTIAL_TASK_TEMPLATE_TYPES.CREDENTIALING, label: 'Credentialing' },
]

export const CREDENTIAL_TASK_TITLE = 'Facility Name'

export const CREDENTIAL_TASK_DESCRIPTION = 'credentialing enabled'
export const CREDENTIALING_SENDER_EMAIL = 'aadi.s@liseinfotech.com'
  // (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CREDENTIALING_SENDER_EMAIL) ||
  // 'aadi.s@liseinfotech.com'

// export const CREDENTIAL_DOCUMENT_SUBTASKS = [
//   'Copy of Medical License:',
//   "Copy of Driver's License:",
//   'Copy of DEA:',
//   'Resume/CV:',
//   'Collaborative Agreement:',
//   'Copy of NPDB:',
//   'Copy of Degree Certificate:',
//   'Copy of AANP/AANC Certificate:',
//   'Copy of Malpractice:',
// ]

const firstDefined = (...values) => {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== '')
}

// const normalizeDocuments = (documents) => {
//   if (!documents) return CREDENTIAL_DOCUMENT_SUBTASKS

//   if (typeof documents === 'string') {
//     try {
//       const parsed = JSON.parse(documents)
//       return normalizeDocuments(parsed)
//     } catch {
//       return documents
//         .split(/\n|,/)
//         .map((item) => item.trim())
//         .filter(Boolean)
//     }
//   }

//   if (Array.isArray(documents)) {
//     const normalized = documents
//       .map((item) => {
//         if (typeof item === 'string') return item.trim()
//         return String(item?.text || item?.Title || item?.title || item?.Name || item?.name || '').trim()
//       })
//       .filter(Boolean)

//     return normalized.length ? normalized : CREDENTIAL_DOCUMENT_SUBTASKS
//   }

//   return CREDENTIAL_DOCUMENT_SUBTASKS
// }

export const getCredentialTaskTemplateLabel = (templateType) => {
  return (
    CREDENTIAL_TASK_TEMPLATE_OPTIONS.find((option) => option.value === templateType)?.label ||
    CREDENTIAL_TASK_TEMPLATE_OPTIONS[0].label
  )
}

const toLocalDateInputValue = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getCredentialTaskToday = () => {
  const date = new Date()
  date.setHours(0, 0, 0, 0)
  return toLocalDateInputValue(date)
}

const buildDefaultCredentialingSubtask = () => ({
  id: null,
  SubtaskId: null,
  text: 'Get DON Email',
  status: 'To Do',
  dueDate: '',
  assignee: [],
  isCompleted: false,
  priority: 'Medium',
  createdBy: '',
})

export const buildCredentialingTemplate = (credentialRequest = {}) => {

  const providerName = firstDefined(
    credentialRequest.ProviderName,
    credentialRequest.providerName,
    credentialRequest.Provider,
    credentialRequest.provider,
  )
  const facilityName = firstDefined(
    credentialRequest.FacilityName,
    credentialRequest.facilityName,
    credentialRequest.Facility,
    credentialRequest.facility,
  )


  return {
    title: firstDefined(
     
       facilityName ? ` ${facilityName}` : '',
      credentialRequest.Title,
      credentialRequest.title,
    ),
    description: firstDefined(
      credentialRequest.Description,
      credentialRequest.description,
        
    ),
    dueDate: firstDefined(credentialRequest.DueDate, credentialRequest.dueDate, getCredentialTaskToday()),
    reminderDate: firstDefined(credentialRequest.ReminderDate, credentialRequest.reminderDate, ''),
    priority: firstDefined(credentialRequest.Priority, credentialRequest.priority, 'Medium'),
    assignees: [],
    patientDetailsEnabled: false,
    providerId: firstDefined(credentialRequest.ProviderID, credentialRequest.ProviderId, credentialRequest.providerId),
    providerName,
    facilityId: firstDefined(credentialRequest.FacilityID, credentialRequest.FacilityId, credentialRequest.facilityId),
    facilityName,
    subtasks: [buildDefaultCredentialingSubtask()],
  }
}

export const inferCredentialTaskTemplateType = () => {
  return CREDENTIAL_TASK_TEMPLATE_TYPES.CREDENTIALING
}

export const getCredentialTaskTemplateDefaults = (credentialRequest = {}) => {
  return buildCredentialingTemplate(credentialRequest)
}

const normalizeText = (value) => String(value || '').trim()

const normalizeDateLabel = (value) => {
  const formatted = formatValueToMMDDYYYY(value)
  return formatted || normalizeText(value)
}

const buildCredentialingTaskDetailsUrl = (task = {}) => {
  if (typeof window === 'undefined') return ''

  const providerId = normalizeText(
    getTaskField(task, 'ProviderID', 'ProviderId', 'providerId')
  )

  if (!providerId) return `${window.location.origin}/home/credentialing`

  return `${window.location.origin}/home/credentialing?providerId=provider-${encodeURIComponent(providerId)}`
}

const getTaskField = (task = {}, ...keys) => {
  for (const key of keys) {
    const value = task?.[key]
    if (value !== undefined && value !== null && normalizeText(value) !== '') {
      return value
    }
  }

  const rawTask = task?.rawTask || {}
  for (const key of keys) {
    const value = rawTask?.[key]
    if (value !== undefined && value !== null && normalizeText(value) !== '') {
      return value
    }
  }

  return ''
}

const normalizeDraftSubtasks = (subtasks) => {
  if (Array.isArray(subtasks)) return subtasks

  if (typeof subtasks === 'string') {
    try {
      const parsed = JSON.parse(subtasks)
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }

  return []
}

const getPendingSubtasks = (subtasks = []) => {
  return normalizeDraftSubtasks(subtasks).filter((item) => {
    const status = normalizeText(item?.status || item?.Status)
    return status.toLowerCase() !== 'done' && status.toLowerCase() !== 'completed'
  })
}

const getAssigneeLabels = (assignees = []) => {
  const list = Array.isArray(assignees) ? assignees : [assignees]

  return list
    .flatMap((item) => {
      if (!item) return []
      if (typeof item === 'string') return [item]

      const label = item?.label || item?.Username || item?.username || item?.UserName || item?.name || item?.value
      return label ? [label] : []
    })
    .filter(Boolean)
}

export const getCredentialingRecipientEmail = (task = {}, providerRecord = {}) => {
  return normalizeText(
    firstDefined(
      getTaskField(task, 'RecipientEmail', 'recipientEmail', 'ProviderEmail', 'providerEmail', 'Email', 'email'),
      providerRecord?.Email,
      providerRecord?.email,
    ),
  )
}

export const buildCredentialingEmailSubject = ({ task = {}, providerRecord = {} } = {}) => {
  const providerName = normalizeText(
    firstDefined(
      getTaskField(task, 'ProviderName', 'providerName', 'Provider', 'provider'),
      providerRecord?.Name,
      providerRecord?.ProviderName,
    ),
  )
  const facilityName = normalizeText(getTaskField(task, 'FacilityName', 'facilityName', 'Facility', 'facility'))
  const resolvedFacilityName =
    facilityName || normalizeText(getTaskField(task, 'Title', 'title')) || 'Facility'
  const resolvedProviderName = providerName || 'Provider'

  return `${resolvedFacilityName} - Credentialing - ${resolvedProviderName}`
}

const resolveCredentialingTemplateHtml = (data) => {
  const normalizedData = normalizeCredentialingApiPayload(data)
  console.log("resolveCredentialingTemplateHtml normalizedData:", normalizedData)
  if (typeof normalizedData === 'string') {
    const text = normalizedData.trim()

    const xmlWrappedHtmlMatch = text.match(/<string\b[^>]*>([\s\S]*?)<\/string>/i)
    if (xmlWrappedHtmlMatch?.[1]) {
      return xmlWrappedHtmlMatch[1].trim()
    }

    return text
  }

  if (!normalizedData || typeof normalizedData !== 'object') {
    return ''
  }

  return String(
    normalizedData?.html ||
      normalizedData?.Html ||
      normalizedData?.htmlBody ||
      normalizedData?.HtmlBody ||
      normalizedData?.body ||
      normalizedData?.Body ||
      normalizedData?.template ||
      normalizedData?.Template ||
      '',
  ).trim()
}

export const fetchCredentialingEmailTemplateRequest = async ({ providerName = '' } = {}) => {
  const payload = {
    ProviderName: providerName,
  }

  const data = await BuildCredentialingEmailHtmlApi(payload)
  const parsedData = parseCredentialingApiPayload(data)

  if (typeof parsedData === 'string') {
    const html = resolveCredentialingTemplateHtml(parsedData)
    console.log("fetchCredentialingEmailTemplateRequest raw template response:", html)
    return {
      success: true,
      html,
      rawTemplate: parsedData,
    }
  }

  const normalizedData = unwrapCredentialingApiResponse(data, 'Failed to build credentialing email template')
  console.log("fetchCredentialingEmailTemplateRequest normalizedData:",  normalizedData)
  const html = resolveCredentialingTemplateHtml(normalizedData)
 console.log("fetchCredentialingEmailTemplateRequest response:",  html)
  return {
    ...normalizedData,
    html,
  }
}

export const buildCredentialingEmailRequestPayload = async ({ task = {}, providerRecord = {}, currentUser = {} } = {}) => {
  const recipientEmail = getCredentialingRecipientEmail(task, providerRecord)
  const subject = buildCredentialingEmailSubject({ task, providerRecord })
  const providerName = normalizeText(
    firstDefined(
      getTaskField(task, 'ProviderName', 'providerName', 'Provider', 'provider'),
      providerRecord?.Name,
      providerRecord?.ProviderName,
    ),
  )
  let templateHtml = ''

  try {
    const templateResponse = await fetchCredentialingEmailTemplateRequest({ providerName })
    templateHtml = templateResponse?.html || ''
  } catch (error) {
    console.error('Failed to fetch credentialing email template from production API:', error)
  }

  const body = templateHtml

  return {
    recipientEmail,
    subject,
    body,
    bodyText: body,
    bodyHtml: body,
    htmlBody: body,
    senderEmail: CREDENTIALING_SENDER_EMAIL,
    senderName: normalizeText(
      currentUser?.name || currentUser?.Name || currentUser?.Username || currentUser?.username || currentUser?.email,
    ),
    task: {
      ProviderID: getTaskField(task, 'ProviderID', 'ProviderId', 'providerId'),
      ProviderName: getTaskField(task, 'ProviderName', 'providerName', 'Provider', 'provider'),
      FacilityID: getTaskField(task, 'FacilityID', 'FacilityId', 'facilityId'),
      FacilityName: getTaskField(task, 'FacilityName', 'facilityName', 'Facility', 'facility'),
      Title: getTaskField(task, 'Title', 'title'),
      Description: getTaskField(task, 'Description', 'description'),
      DueDate: getTaskField(task, 'DueDate', 'dueDate'),
      Priority: getTaskField(task, 'Priority', 'priority'),
      AssignedUsersJson:
        task?.AssignedUsersJson || task?.AssignedUsers || task?.Assignee || task?.assignedUsers || [],
      SubtasksJson: task?.SubtasksJson || task?.subtask || task?.subtasks || [],
    },
    provider: {
      Email: providerRecord?.Email || providerRecord?.email || '',
      Name: providerRecord?.Name || providerRecord?.ProviderName || '',
      ProviderName: providerRecord?.ProviderName || providerRecord?.Name || '',
    },
  }
}

const isErrorLikeResponse = (value) => {
  return Boolean(
    value &&
      typeof value === 'object' &&
      (value instanceof Error ||
        value?.name === 'AxiosError' ||
        value?.isAxiosError ||
        value?.response ||
        value?.request ||
        value?.message === 'Network Error'),
  )
}

const extractCredentialingApiErrorMessage = (value, fallbackMessage) => {
  const responseData = value?.response?.data

  if (typeof responseData?.d === 'string') {
    try {
      const parsed = JSON.parse(responseData.d)
      const parsedMessage = parsed?.error || parsed?.message || parsed?.Message
      if (parsedMessage) return parsedMessage
    } catch {
      if (responseData.d.trim()) return responseData.d
    }
  }

  const normalizedResponseData = parseCredentialingApiPayload(responseData)
  if (normalizedResponseData && typeof normalizedResponseData === 'object') {
    const normalizedMessage =
      normalizedResponseData?.error ||
      normalizedResponseData?.message ||
      normalizedResponseData?.Message
    if (normalizedMessage) return normalizedMessage
  }

  if (typeof responseData === 'string' && responseData.trim()) {
    return responseData
  }

  return value?.response?.data?.error || value?.response?.data?.message || value?.message || fallbackMessage
}

const parseCredentialingApiPayload = (value) => {
  const raw = value?.d ?? value?.data ?? value

  if (typeof raw === 'string') {
    const trimmedRaw = raw.trim()

    if (trimmedRaw.startsWith('<')) {
      return trimmedRaw
    }

    try {
      return JSON.parse(raw)
    } catch {
      return raw
    }
  }

  return raw
}

const normalizeNestedCredentialingMetadata = (value) => {
  const parsed = parseCredentialingApiPayload(value)

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return null
  }

  return {
    ...parsed,
    messageId: parsed.messageId ?? parsed.MessageId ?? '',
    conversationId: parsed.conversationId ?? parsed.ConversationId ?? '',
    internetMessageId: parsed.internetMessageId ?? parsed.InternetMessageId ?? '',
    changeKey: parsed.changeKey ?? parsed.ChangeKey ?? '',
    subject: parsed.subject ?? parsed.Subject ?? '',
    sentDateTime: parsed.sentDateTime ?? parsed.SentDateTime ?? '',
    receivedDateTime: parsed.receivedDateTime ?? parsed.ReceivedDateTime ?? '',
    from: parsed.from ?? parsed.From ?? '',
    sender: parsed.sender ?? parsed.Sender ?? '',
    toRecipients: parsed.toRecipients ?? parsed.ToRecipients ?? [],
    bodyPreview: parsed.bodyPreview ?? parsed.BodyPreview ?? '',
    webLink: parsed.webLink ?? parsed.WebLink ?? parsed.draftWebLink ?? parsed.DraftWebLink ?? '',
    isDraft: parsed.isDraft ?? parsed.IsDraft ?? false,
    isRead: parsed.isRead ?? parsed.IsRead ?? false,
    parentFolderId: parsed.parentFolderId ?? parsed.ParentFolderId ?? '',
  }
}

const buildFallbackEmailMetadata = (parsed = {}) => {
  const messageId = parsed.messageId ?? parsed.MessageId ?? ''
  const conversationId = parsed.conversationId ?? parsed.ConversationId ?? ''

  if (!messageId && !conversationId) {
    return null
  }

  return {
    messageId,
    conversationId,
    internetMessageId: parsed.internetMessageId ?? parsed.InternetMessageId ?? '',
    changeKey: parsed.changeKey ?? parsed.ChangeKey ?? '',
    subject: parsed.subject ?? parsed.Subject ?? '',
    sentDateTime: parsed.sentDateTime ?? parsed.SentDateTime ?? '',
    receivedDateTime: parsed.receivedDateTime ?? parsed.ReceivedDateTime ?? '',
    from: parsed.from ?? parsed.From ?? '',
    sender: parsed.sender ?? parsed.Sender ?? '',
    toRecipients: parsed.toRecipients ?? parsed.ToRecipients ?? [],
    bodyPreview: parsed.bodyPreview ?? parsed.BodyPreview ?? '',
    webLink: parsed.webLink ?? parsed.WebLink ?? parsed.draftWebLink ?? parsed.DraftWebLink ?? '',
    isDraft: parsed.isDraft ?? parsed.IsDraft ?? true,
    isRead: parsed.isRead ?? parsed.IsRead ?? false,
    parentFolderId: parsed.parentFolderId ?? parsed.ParentFolderId ?? '',
  }
}

const normalizeCredentialingArrayField = (value) => {
  if (Array.isArray(value)) return value
  if (typeof value !== 'string' || !value.trim()) return []

  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

const normalizeReplyEmailAddress = (value) => {
  if (!value) return ''
  if (typeof value === 'string') return value.trim()

  return String(
    value?.emailAddress?.address ||
      value?.address ||
      value?.Address ||
      value?.from ||
      value?.From ||
      value?.sender ||
      value?.Sender ||
      '',
  ).trim()
}

const normalizeReplyRecipients = (value) => {
  if (!Array.isArray(value)) return []

  return value
    .map((item) => normalizeReplyEmailAddress(item))
    .filter(Boolean)
}

const normalizeCredentialingReplyItem = (reply = {}) => {
  if (!reply || typeof reply !== 'object') {
    return {
      messageId: '',
      conversationId: '',
      internetMessageId: '',
      from: '',
      toRecipients: [],
      subject: '',
      sentDateTime: '',
      receivedDateTime: '',
      bodyPreview: '',
      isRead: false,
      parentFolderId: '',
    }
  }

  return {
    ...reply,
    messageId: reply?.messageId ?? reply?.MessageId ?? reply?.id ?? reply?.Id ?? '',
    conversationId: reply?.conversationId ?? reply?.ConversationId ?? '',
    internetMessageId: reply?.internetMessageId ?? reply?.InternetMessageId ?? '',
    from: normalizeReplyEmailAddress(
      reply?.from ??
        reply?.From ??
        reply?.sender ??
        reply?.Sender ??
        reply?.fromRecipient ??
        reply?.FromRecipient,
    ),
    toRecipients: normalizeReplyRecipients(reply?.toRecipients ?? reply?.ToRecipients ?? []),
    subject: String(reply?.subject ?? reply?.Subject ?? '').trim(),
    sentDateTime: reply?.sentDateTime ?? reply?.SentDateTime ?? '',
    receivedDateTime: reply?.receivedDateTime ?? reply?.ReceivedDateTime ?? '',
    bodyPreview: String(
      reply?.bodyPreview ??
        reply?.BodyPreview ??
        reply?.messagePreview ??
        reply?.MessagePreview ??
        reply?.body ??
        reply?.Body ??
        reply?.content ??
        reply?.Content ??
        '',
    ).trim(),
    isRead: Boolean(reply?.isRead ?? reply?.IsRead),
    parentFolderId: reply?.parentFolderId ?? reply?.ParentFolderId ?? '',
  }
}

const normalizeCredentialingApiPayload = (value) => {
  const parsed = parseCredentialingApiPayload(value)
  console.log('normalizeCredentialingApiPayload parsed:', parsed)
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return parsed
  }

  const normalizedEmailMetadata =
    normalizeNestedCredentialingMetadata(parsed.emailMetadata ?? parsed.EmailMetadata) ||
    buildFallbackEmailMetadata(parsed)

  return {
    ...parsed,
    success: parsed.success ?? parsed.Success,
    message: parsed.message ?? parsed.Message,
    subject: parsed.subject ?? parsed.Subject,
    recipientEmail: parsed.recipientEmail ?? parsed.RecipientEmail,
    draftWebLink: parsed.draftWebLink ?? parsed.DraftWebLink,
    messageId: parsed.messageId ?? parsed.MessageId,
    conversationId: parsed.conversationId ?? parsed.ConversationId,
    changeKey: parsed.changeKey ?? parsed.ChangeKey,
    internetMessageId: parsed.internetMessageId ?? parsed.InternetMessageId,
    emailMetadata: normalizedEmailMetadata,
    replies: normalizeCredentialingArrayField(parsed.replies ?? parsed.Replies).map((item) =>
      normalizeCredentialingReplyItem(item),
    ),
    attachmentWarnings: normalizeCredentialingArrayField(parsed.attachmentWarnings ?? parsed.AttachmentWarnings),
    metadataWarning: parsed.metadataWarning ?? parsed.MetadataWarning,
  }
}

const buildDraftComposeLink = ({ draftWebLink = '', messageId = '' } = {}) => {
  const normalizedMessageId = String(messageId || '').trim()
  if (!normalizedMessageId) return ''

  let origin = 'https://outlook.office.com'

  if (draftWebLink) {
    try {
      origin = new URL(draftWebLink).origin || origin
    } catch {
      origin = 'https://outlook.office.com'
    }
  }

  return `${origin}/mail/deeplink/compose/${encodeURIComponent(normalizedMessageId)}`
}

const buildLegacyDraftReadLink = ({ draftWebLink = '', messageId = '' } = {}) => {
  const normalizedMessageId = String(messageId || '').trim()
  if (!normalizedMessageId) return ''

  const encodedMessageId = encodeURIComponent(normalizedMessageId)
  return `https://outlook.cloud.microsoft/mail/deeplink/read/${encodedMessageId}?ItemID=${encodedMessageId}&exvsurl=1`
}

const buildDraftEditWebLink = ({ draftWebLink = '', messageId = '' } = {}) => {
  const normalizedMessageId = String(messageId || '').trim()
  if (!normalizedMessageId) return ''

  let origin = 'https://outlook.office365.com'

  if (draftWebLink) {
    try {
      const parsedUrl = new URL(draftWebLink)
      origin = parsedUrl.origin || origin

      if (parsedUrl.searchParams.get('ItemID')) {
        parsedUrl.searchParams.set('viewmodel', 'EditMessageItem')
        parsedUrl.searchParams.set('exvsurl', '1')
        return parsedUrl.toString()
      }
    } catch {
      origin = 'https://outlook.office365.com'
    }
  }

  return `${origin}/owa/?ItemID=${encodeURIComponent(normalizedMessageId)}&exvsurl=1&viewmodel=EditMessageItem`
}

const unwrapCredentialingApiResponse = (data, fallbackMessage) => {
  if (isErrorLikeResponse(data)) {
    const responseMessage = extractCredentialingApiErrorMessage(data, fallbackMessage)
    throw new Error(responseMessage)
  }

  const normalizedData = normalizeCredentialingApiPayload(data)

  if (normalizedData?.success === false || normalizedData?.Success === false) {
    throw new Error(normalizedData?.error || normalizedData?.message || normalizedData?.Message || fallbackMessage)
  }

  return {
    ...normalizedData,
    legacyDraftWebLink:
      normalizedData?.legacyDraftWebLink ||
      normalizedData?.LegacyDraftWebLink ||
      buildLegacyDraftReadLink({
        draftWebLink: normalizedData?.draftWebLink || normalizedData?.DraftWebLink,
        messageId: normalizedData?.messageId || normalizedData?.MessageId,
      }),
    draftEditWebLink:
      normalizedData?.draftEditWebLink ||
      normalizedData?.DraftEditWebLink ||
      buildDraftEditWebLink({
        draftWebLink: normalizedData?.draftWebLink || normalizedData?.DraftWebLink,
        messageId: normalizedData?.messageId || normalizedData?.MessageId,
      }),
    draftComposeLink:
      normalizedData?.draftComposeLink ||
      normalizedData?.DraftComposeLink ||
      buildDraftComposeLink({
        draftWebLink: normalizedData?.draftWebLink || normalizedData?.DraftWebLink,
        messageId: normalizedData?.messageId || normalizedData?.MessageId,
      }),
  }
}

export const sendCredentialingEmailRequest = async (payload = {}) => {
  const data = await SendCredentialingEmailApi(JSON.stringify(payload))
  return unwrapCredentialingApiResponse(data, 'Failed to send credentialing email')
}

export const createCredentialingEmailDraftRequest = async (payload = {}) => {
  console.log('Creating credentialing email draft with payload:', payload)
  console.log('createCredentialingEmailDraftRequest response:', payload)

  const data = await CreateDraftMail(JSON.stringify(payload))
  return unwrapCredentialingApiResponse(data, 'Failed to create credentialing email draft')
}

export const fetchCredentialingEmailReplies = async (conversationId, options = {}) => {
  const payload = {
    conversationId,
    subject: options?.subject || '',
    recipientEmail: options?.recipientEmail || '',
    sentDateTime: options?.sentDateTime || '',
  }

  console.log('fetchCredentialingEmailReplies request payload:', payload, JSON.stringify(payload))
  const data = await FetchCredentialingEmailRepliesApi(JSON.stringify(payload))
  console.log('fetchCredentialingEmailReplies response:', {
    requestedConversationId: conversationId,
    options,
    data,
  })
  return unwrapCredentialingApiResponse(data, 'Failed to fetch credentialing email replies')
}

export const syncCredentialingEmailThreadRequest = async (payload = {}) => {
  const data = await SyncCredentialingEmailThreadApi(JSON.stringify(payload))
  return unwrapCredentialingApiResponse(data, 'Failed to sync credentialing email thread')
}

export const markCredentialingReplyAsReadRequest = async (messageId) => {
  const payloadVariants = [
    {
      payload: JSON.stringify({ messageId }),
      options: { wrapPayload: true },
      label: 'wrapped-messageId',
    },
    {
      payload: JSON.stringify({ MessageId: messageId }),
      options: { wrapPayload: true },
      label: 'wrapped-MessageId',
    },
    {
      payload: { messageId },
      options: { wrapPayload: false },
      label: 'direct-messageId',
    },
    {
      payload: { MessageId: messageId },
      options: { wrapPayload: false },
      label: 'direct-MessageId',
    },
  ]

  let lastError = null

  for (const variant of payloadVariants) {
    const data = await MarkCredentialingReplyAsReadApi(variant.payload, variant.options)

    try {
      const normalized = unwrapCredentialingApiResponse(data, 'Failed to mark credentialing reply as read')
      console.log('MarkCredentialingReplyAsRead succeeded with payload variant:', variant.label)
      return normalized
    } catch (error) {
      lastError = error
      console.warn('MarkCredentialingReplyAsRead failed with payload variant:', variant.label, error)
    }
  }

  throw lastError || new Error('Failed to mark credentialing reply as read')
}

export const buildCredentialingEmailBody = ({ task = {}, providerRecord = {}, currentUser = {} } = {}) => {
  const providerName = normalizeText(
    firstDefined(
      getTaskField(task, 'ProviderName', 'providerName', 'Provider', 'provider'),
      providerRecord?.Name,
      providerRecord?.ProviderName,
    ),
  )
  const facilityName = normalizeText(getTaskField(task, 'FacilityName', 'facilityName', 'Facility', 'facility'))
  const taskTitle = normalizeText(getTaskField(task, 'Title', 'title')) || 'Credentialing Task'
  const taskDescription = normalizeText(getTaskField(task, 'Description', 'description'))
  const dueDate = normalizeDateLabel(getTaskField(task, 'DueDate', 'dueDate'))
  const priority = normalizeText(getTaskField(task, 'Priority', 'priority')) || 'Medium'
  const assignees = getAssigneeLabels(
    task?.AssignedUsersJson || task?.AssignedUsers || task?.Assignee || task?.assignedUsers || [],
  )
  const pendingSubtasks = getPendingSubtasks(task?.SubtasksJson || task?.subtask || task?.subtasks || [])
  const detailsUrl = buildCredentialingTaskDetailsUrl(task)
  const senderName = normalizeText(
    currentUser?.name || currentUser?.Name || currentUser?.Username || currentUser?.username || currentUser?.email,
  )
  const headerTitle = [facilityName || taskTitle, providerName].filter(Boolean).join(' : ') || taskTitle
  const assignedToLabel = assignees.length ? assignees.join(', ') : 'N/A'
  const metadataLines = [
    'TASK METADATA',
    '-------------',
    `TASK: ${taskTitle}`,
    `FACILITY: ${facilityName || 'N/A'}`,
    `DUE DATE: ${dueDate || 'N/A'}`,
    `PRIORITY: ${priority || 'N/A'}`,
    `ASSIGNED TO: ${assignedToLabel}`,
    `DESCRIPTION: ${taskDescription || 'N/A'}`,
  ]

  const lines = [
    headerTitle,
    '______________',
    '',
    `Hello ${providerName || 'Provider'},`,
    '',
    'Please review the credentialing task below. This task requires your immediate attention to maintain compliance status.',
    '',
    ...metadataLines,
  ]

  if (detailsUrl) {
    lines.push('', 'VIEW FULL TASK DETAILS:', detailsUrl)
  }

  if (pendingSubtasks.length) {
    lines.push('', 'Pending Subtasks:')
    pendingSubtasks.forEach((item) => {
      const subtaskTitle = normalizeText(item?.text || item?.Text || item?.title || item?.Title) || 'Untitled subtask'
      const subtaskDueDate = normalizeDateLabel(item?.dueDate || item?.DueDate)
      lines.push(`- ${subtaskTitle}${subtaskDueDate ? ` (${subtaskDueDate})` : ''}`)
    })
  }

  if (senderName) {
    lines.push('', '----------------------------------------', '', 'Best,', senderName, 'System Administrator | TrustLink Credentialing')
  }

  return lines.join('\n')
}

export const buildOutlookComposeUrl = ({ to = '', subject = '', body = '', cc = '', bcc = '' } = {}) => {
  const query = [
    ['view', 'cm'],
    ['fs', '1'],
    ['to', normalizeText(to)],
    ['subject', normalizeText(subject)],
    ['body', body || ''],
    ['cc', normalizeText(cc)],
    ['bcc', normalizeText(bcc)],
  ]
    .filter(([, value]) => String(value || '').trim() !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

  return `https://outlook.office.com/mail/?${query}`
}

export const buildOutlookCloudComposeUrl = ({ to = '', subject = '', body = '', cc = '', bcc = '' } = {}) => {
  const query = [
    ['view', 'cm'],
    ['fs', '1'],
    ['to', normalizeText(to)],
    ['subject', normalizeText(subject)],
    ['body', body || ''],
    ['cc', normalizeText(cc)],
    ['bcc', normalizeText(bcc)],
  ]
    .filter(([, value]) => String(value || '').trim() !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

  return `https://outlook.cloud.microsoft/mail/?${query}`
}

export const buildCredentialingOutlookDraft = ({ task = {}, providerRecord = {}, currentUser = {} } = {}) => {
  const to = getCredentialingRecipientEmail(task, providerRecord)
  const subject = buildCredentialingEmailSubject({ task, providerRecord })
  const body = buildCredentialingEmailBody({ task, providerRecord, currentUser })
  const defaultDeepLinkUrl = `https://outlook.office.com/mail/deeplink/compose?${[
    ['popoutv2', '1'],
    ['noPrompt', '1'],
    ['to', normalizeText(to)],
    ['subject', normalizeText(subject)],
    ['body', body || ''],
  ]
    .filter(([, value]) => String(value || '').trim() !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')}`

  return {
    to,
    subject,
    body,
    url: defaultDeepLinkUrl,
    cloudUrl: buildOutlookCloudComposeUrl({ to, subject, body }),
    fallbackUrl: buildOutlookComposeUrl({ to, subject, body }),
  }
}
